import React, { Fragment } from "react"

import ContentLoaderTags from "../../../common/content-loading/ContentLoaderTags"
import Tags from "../../../common/tags/Tags"
import TagItem from "../../../common/tags/TagItem"

const CommunityViewHierarchy = ({
    parent,
    subGroups,
    subCommunities,
    reference,
    isFetching
}) => (
    <div className="widget">
        <div className="widget-content">
            {reference && (
                <Fragment>
                    <h3 key="reference-header" className="first-heading">
                        <span className="icon icon-concepts" />
                        Derived From {reference.label}
                    </h3>
                    <Tags key={reference.name} className="clearfix">
                        <TagItem isGrey={true}>{reference.name}</TagItem>
                    </Tags>
                </Fragment>
            )}
            <h3 className={!reference ? "first-heading" : ""}>
                <span className="icon icon-community" />Parent community
            </h3>
            <ContentLoaderTags isFetching={isFetching} tags={1}>
                <Tags className="clearfix">
                    {parent ? (
                        <TagItem isGrey={true}>{parent.name}</TagItem>
                    ) : (
                        "No parent community"
                    )}
                </Tags>
            </ContentLoaderTags>
            <h3>
                <span className="icon icon-community" />Sub-communities
            </h3>
            <ContentLoaderTags
                isFetching={isFetching}
                minLines={1}
                maxLines={2}
            >
                <Tags className="clearfix">
                    {subCommunities && subCommunities.length > 0
                        ? subCommunities.map(({ id, name }) => (
                              <TagItem isGrey={true} key={id}>
                                  {name}
                              </TagItem>
                          ))
                        : "No sub-communities"}
                </Tags>
            </ContentLoaderTags>
            <h3>
                <span className="icon icon-community" />Sub-groups
            </h3>
            <ContentLoaderTags
                isFetching={isFetching}
                minLines={1}
                maxLines={3}
            >
                <Tags className="clearfix">
                    {subGroups && subGroups.length > 0
                        ? subGroups.map(({ id, name }) => (
                              <TagItem isGrey={true} key={id}>
                                  {name}
                              </TagItem>
                          ))
                        : "No sub-groups"}
                </Tags>
            </ContentLoaderTags>
        </div>
    </div>
)

export default CommunityViewHierarchy
